export default "__VITE_ASSET__E53PalBf__"